module.exports = __webpack_public_path__ + "img/William Sellers.60828bd0.jpg";